module.exports = __webpack_public_path__ + "static/media/image (26).139c79f0.jpg";